import { useState } from 'react';

const ROWS_PER_PAGE = 50;
const INITIAL_PAGE = 1;

export const useTablePagination = rows => {
  const initialRowsNumber = rows.length;

  const [page, setPage] = useState(INITIAL_PAGE);
  const [rowsNumber, setRowsNumber] = useState(initialRowsNumber);

  if (initialRowsNumber !== rowsNumber) {
    setPage(INITIAL_PAGE);
    setRowsNumber(initialRowsNumber);
  }

  const count = Math.ceil(rowsNumber / ROWS_PER_PAGE);
  const rowsByPage = rows.slice(
    (page - 1) * ROWS_PER_PAGE,
    (page - 1) * ROWS_PER_PAGE + ROWS_PER_PAGE,
  );
  const start = (page - 1) * ROWS_PER_PAGE + 1;
  const end = Math.min(page * ROWS_PER_PAGE, rowsNumber);
  const counter = `${start} - ${end} of ${rowsNumber}`;

  return {
    page,
    count,
    rowsByPage,
    counter,
    setPage,
  };
};
